import { createSelector } from '@reduxjs/toolkit'
import { LookupType } from '@lk/api'

import { getLookups } from '../root.selectors'

// REVIEW: not used yet (check withLookups)
export const isAnyLookupLoading = createSelector(getLookups, (slice) => slice.status === 'loading')
export const getLookupsByType = createSelector(
  [getLookups, (_state, type: LookupType) => type],
  (slice, type) => slice.byType[type],
)
